import { useQuery } from "@tanstack/react-query";
import { getEvvDevHelpAvailability } from "./evv-dev-help.api";

export const EVV_DEV_HELP_AVAILABILITY_KEY = "evv_dev_help_availability";

/**
 * Whether the agency has the feature (`enabled`) and whether this member may use the
 * dashboard (`canManage`). Callers treat anything but `true` as off: it is `undefined`
 * while loading and on error.
 */
export function useEvvDevHelpAvailability() {
  return useQuery({
    queryKey: [EVV_DEV_HELP_AVAILABILITY_KEY],
    queryFn: getEvvDevHelpAvailability,
    staleTime: 60 * 60 * 1000,
    retry: false,
  });
}
